import { Routes } from '@angular/router';
import { AppLayout } from './app/layout/components/app.layout';
import { AuthGuard } from './components/shared/data-access/guards/auth.guard';
import { SuperAdminGuard } from './components/shared/data-access/guards/super-admin.guard';
import { HomeGuard } from './components/shared/data-access/guards/home.guard';
import { SuperAdminAppLayout } from './app/layout/components/super-admin/super-admin.layout';

// export const appRoutes: Routes = [
//   {
//     path: '',
//     component: AppLayout,   // ensure AppLayout is standalone
//     canActivate: [AuthGuard],
//     children: [
//       {
//         path: '',
//         loadComponent: () => import('./components/dashboard/feature-landing/landing.component').then(c => c.LandingComponent),
//       },
//       {
//           path: 'pages',
//           loadChildren: () => import('./app/pages/pages.routes'),
//       },

//       // Orders
//       {
//         path: 'orders/live',
//         canActivate: [AuthGuard],
//         loadComponent: () =>
//           import('./components/orders/feature-live-orders/live-orders.component').then(c => c.LiveOrdersComponent),
//       },
//       {
//         path: 'orders/history',
//         canActivate: [AuthGuard],
//         loadComponent: () =>
//           import('./components/dashboard/feature-landing/landing.component').then(c => c.LandingComponent),
//       },

//       // Menu Management
//       {
//         path: 'menu',
//         canActivate: [AuthGuard],
//         loadComponent: () =>
//           import('./components/dashboard/feature-landing/landing.component').then(c => c.LandingComponent),
//       },
//       {
//         path: 'categories',
//         canActivate: [AuthGuard],
//         loadComponent: () =>
//           import('./components/dashboard/feature-landing/landing.component').then(c => c.LandingComponent),
//       },
//       {
//         path: 'menu/specials',
//         canActivate: [AuthGuard],
//         loadComponent: () =>
//           import('./components/dashboard/feature-landing/landing.component').then(c => c.LandingComponent),
//       },
//       {
//         path: 'menu/discounts',
//         canActivate: [AuthGuard],
//         loadComponent: () =>
//           import('./components/dashboard/feature-landing/landing.component').then(c => c.LandingComponent),
//       },

//       // Reports
//       {
//         path: 'reports/sales',
//         canActivate: [AuthGuard],
//         loadComponent: () =>
//           import('./components/dashboard/feature-landing/landing.component').then(c => c.LandingComponent),
//       },
//       {
//         path: 'reports/items',
//         canActivate: [AuthGuard],
//         loadComponent: () =>
//           import('./components/dashboard/feature-landing/landing.component').then(c => c.LandingComponent),
//       },

//       // Course
//       {
//         path: 'courses',
//         canActivate: [AuthGuard],
//         loadComponent: () =>
//           import('./components/dashboard/feature-landing/landing.component').then(c => c.LandingComponent),
//       },
//       {
//         path: 'courses/payment',
//         canActivate: [AuthGuard],
//         loadComponent: () =>
//           import('./components/dashboard/feature-landing/landing.component').then(c => c.LandingComponent),
//       },

//       // User Management
//       {
//         path: 'users',
//         canActivate: [AuthGuard],
//         loadComponent: () =>
//           import('./components/dashboard/feature-landing/landing.component').then(c => c.LandingComponent),
//       },
//       {
//         path: 'users/invite',
//         canActivate: [AuthGuard],
//         loadComponent: () =>
//           import('./components/dashboard/feature-landing/landing.component').then(c => c.LandingComponent),
//       },

//       // Notifications
//       {
//         path: 'notifications',
//         canActivate: [AuthGuard],
//         loadComponent: () =>
//           import('./components/dashboard/feature-landing/landing.component').then(c => c.LandingComponent),
//       },

//       // Settings
//       {
//         path: 'settings/organization',
//         canActivate: [AuthGuard],
//         loadComponent: () =>
//           import('./components/dashboard/feature-landing/landing.component').then(c => c.LandingComponent),
//       },
//       {
//         path: 'settings/profile',
//         canActivate: [AuthGuard],
//         loadComponent: () =>
//           import('./components/dashboard/feature-landing/landing.component').then(c => c.LandingComponent),
//       },
//     ],
//   },
//   {
//       path: '',
//       loadChildren: () => import('./app/pages/auth/auth.routes'),
//   },
//   { path: '**', redirectTo: '/notfound' },
// ];

export const appRoutes: Routes = [
  // Super Admin (Clubside): /super-admin/*
  {
    path: 'super-admin',
    component: SuperAdminAppLayout, // use a separate layout if you prefer
    canActivate: [AuthGuard, SuperAdminGuard],
    children: [
      // Company setup is where Clubside's work starts, so the root opens on it.
      { path: '', redirectTo: 'companies', pathMatch: 'full' },

      // Core Features / Functionality
      {
        path: 'companies', // Companies
        loadComponent: () =>
          import('./components//super-admin/company/feature-companies/companies.component').then(
            (c) => c.CompaniesComponent,
          ),
      },
      {
        path: 'courses', // Multi-Course Oversight
        loadComponent: () =>
          import('./components/super-admin/company-courses/feature-courses-overview/courses-overview.component').then(
            (c) => c.CoursesOverviewComponent,
          ),
      },
      {
        path: 'course-setup', // Course Setup & Support
        loadComponent: () =>
          import('./components/super-admin/company-courses/feature-company-courses/company-courses.component').then(
            (c) => c.CompanyCoursesComponent,
          ),
      },
      {
        path: 'global-menu', // Globa Menu
        loadComponent: () =>
          import('./components/super-admin/global-menu/feature-sku-menu-builder/sku-menu-builder.component').then(
            (c) => c.GlobalMenuBuilderComponent,
          ),
      },
      {
        path: 'company-employees', // Company Employees
        loadComponent: () =>
          import('./components/super-admin/company-users/feature-company-employees/company-employees.component').then(
            (c) => c.CompanyEmployeesComponent,
          ),
      },
      {
        path: 'support', // Support hub
        loadComponent: () =>
          import('./components/dashboard/feature-landing/landing.component').then(
            (c) => c.LandingComponent,
          ),
      },
      {
        path: 'billing', // Billing & Revenue
        loadComponent: () =>
          import('./components/dashboard/feature-landing/landing.component').then(
            (c) => c.LandingComponent,
          ),
      },
      {
        path: 'compliance', // Compliance & Standards
        loadComponent: () =>
          import('./components/dashboard/feature-landing/landing.component').then(
            (c) => c.LandingComponent,
          ),
      },
      {
        path: 'ads', // Ad Management (Platform-Level)
        loadComponent: () =>
          import('./components/dashboard/feature-landing/landing.component').then(
            (c) => c.LandingComponent,
          ),
      },
      {
        path: 'overrides', // Override Controls
        loadComponent: () =>
          import('./components/dashboard/feature-landing/landing.component').then(
            (c) => c.LandingComponent,
          ),
      },

      // Super Admin Reports
      {
        path: 'reports/overview', // Super Admin Reports
        loadComponent: () =>
          import('./components/dashboard/feature-landing/landing.component').then(
            (c) => c.LandingComponent,
          ),
      },
      {
        path: 'reports/revenue-billing', // Revenue & Billing Reports
        loadComponent: () =>
          import('./components/dashboard/feature-landing/landing.component').then(
            (c) => c.LandingComponent,
          ),
      },
      {
        path: 'reports/adoption-engagement', // Adoption & Engagement
        loadComponent: () =>
          import('./components/dashboard/feature-landing/landing.component').then(
            (c) => c.LandingComponent,
          ),
      },
      {
        path: 'reports/customer-experience', // Customer Experience Reports
        loadComponent: () =>
          import('./components/dashboard/feature-landing/landing.component').then(
            (c) => c.LandingComponent,
          ),
      },
      {
        path: 'reports/menu-inventory-trends', // Menu & Inventory Trends
        loadComponent: () =>
          import('./components/dashboard/feature-landing/landing.component').then(
            (c) => c.LandingComponent,
          ),
      },
      {
        path: 'reports/operational-compliance', // Operational Compliance
        loadComponent: () =>
          import('./components/dashboard/feature-landing/landing.component').then(
            (c) => c.LandingComponent,
          ),
      },
      {
        path: 'reports/employee-activity', // Employee Activity Report
        loadComponent: () =>
          import('./components/dashboard/feature-landing/landing.component').then(
            (c) => c.LandingComponent,
          ),
      },
      {
        path: 'reports/platform-health', // Platform-Wide Health Report
        loadComponent: () =>
          import('./components/dashboard/feature-landing/landing.component').then(
            (c) => c.LandingComponent,
          ),
      },
      {
        path: 'reports/churn-retention', // Churn & Retention Analysis
        loadComponent: () =>
          import('./components/dashboard/feature-landing/landing.component').then(
            (c) => c.LandingComponent,
          ),
      },
      {
        path: 'reports/support-escalations', // Support & Escalations
        loadComponent: () =>
          import('./components/dashboard/feature-landing/landing.component').then(
            (c) => c.LandingComponent,
          ),
      },
    ],
  },

  // Admin (Course Admin): no prefix
  {
    path: '',
    component: AppLayout, // ensure AppLayout is standalone
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        canActivate: [HomeGuard],
        loadComponent: () =>
          import('./components/dashboard/feature-landing/landing.component').then(
            (c) => c.LandingComponent,
          ),
      },
      {
        path: 'pages',
        loadChildren: () => import('./app/pages/pages.routes'),
      },

      // Orders (Order Monitoring)
      {
        path: 'orders/live',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./components/orders/feature-live-orders/live-orders.component').then(
            (c) => c.LiveOrdersComponent,
          ),
      },
      {
        path: 'orders/history',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./components/orders/feature-order-history/order-history.component').then(
            (c) => c.OrderHistoryComponent,
          ),
      },

      // Menu & Inventory Management
      {
        path: 'menu',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./components/menu/feature-menu-builder/menu-builder.component').then(
            (c) => c.MenuBuilderComponent,
          ),
      },
      {
        path: 'inventory',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./components/dashboard/feature-landing/landing.component').then(
            (c) => c.LandingComponent,
          ),
      },
      {
        path: 'menu/tags',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./components/menu/feature-menu-tags/menu-tags.component').then(
            (c) => c.MenuTagsComponent,
          ),
      },
      {
        path: 'menu/modifiers',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./components/menu/feature-menu-modifiers/menu-modifiers.component').then(
            (c) => c.MenuModifiersComponent,
          ),
      },
      {
        path: 'menu/specials',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./components/discount-specials/feature-discount-and-specials/discount-specials.component').then(
            (c) => c.DiscountSpecialsComponent,
          ),
      },

      // Reports & Analytics
      {
        path: 'reports/overview',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./components/reports/feature-sales-overview/sales-overview.component').then(
            (c) => c.SalesOverviewComponent,
          ),
      },
      {
        path: 'reports/sales-time',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./components/reports/feature-sales-by-time/sales-by-time.component').then(
            (c) => c.SalesByTimeComponent,
          ),
      },
      {
        path: 'reports/top-items',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./components/reports/feature-top-items/top-items.component').then(
            (c) => c.TopItemsComponent,
          ),
      },
      {
        path: 'reports/modifiers',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./components/reports/feature-modifier-rate/modifier-rate.component').then(
            (c) => c.ModifierRateComponent,
          ),
      },
      {
        path: 'reports/fulfillment',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./components/reports/feature-fulfillment-speed/fulfillment-speed.component').then(
            (c) => c.FulfillmentSpeedComponent,
          ),
      },
      {
        path: 'reports/cancellations',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./components/reports/feature-cancelations/cancelations.component').then(
            (c) => c.CancelationsComponent,
          ),
      },
      {
        path: 'reports/locations',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./components/reports/feature-orders-by-location/orders-by-location.component').then(
            (c) => c.OrdersByLocationComponent,
          ),
      },

      // Course
      {
        path: 'courses', // Multi-Course Oversight
        loadComponent: () =>
          import('./components/courses/feature-course-settings/course-settings.component').then(
            (c) => c.CourseSettingsComponent,
          ),
      },
      {
        path: 'courses/payment',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./components/dashboard/feature-landing/landing.component').then(
            (c) => c.LandingComponent,
          ),
      },

      // Geo-Fencing
      {
        path: 'geo-fencing',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./components/dashboard/feature-landing/landing.component').then(
            (c) => c.LandingComponent,
          ),
      },

      // Promotions & Ads (Course-Level)
      {
        path: 'promotions',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./components/dashboard/feature-landing/landing.component').then(
            (c) => c.LandingComponent,
          ),
      },

      // Employee Oversight
      {
        path: 'users',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./components/users/feature-admin-users/admin-users.component').then(
            (c) => c.AdminUsersComponent,
          ),
      },
      {
        path: 'users/invite',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./components/dashboard/feature-landing/landing.component').then(
            (c) => c.LandingComponent,
          ),
      },

      // Notifications
      {
        path: 'notifications',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./components/dashboard/feature-landing/landing.component').then(
            (c) => c.LandingComponent,
          ),
      },

      // Settings
      {
        path: 'settings/organization',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./components/dashboard/feature-landing/landing.component').then(
            (c) => c.LandingComponent,
          ),
      },
      {
        path: 'settings/profile',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./components/users/feature-profile-settings/profile-settings.component').then(
            (c) => c.ProfileSettingsComponent,
          ),
      },
      {
        path: 'settings/payment',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./components/payment-settings/payment-settings.component').then(
            (c) => c.PaymentSettingsComponent,
          ),
      },
    ],
  },

  // Auth pages (public)
  {
    path: '',
    loadChildren: () => import('./app/pages/auth/auth.routes'),
  },
];
